"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var SelectFill = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M10.7847,14.9609 L7.9997,12.1759 L8.7067,11.4689 L10.7847,13.5469 L15.2927,9.0389 L15.9997,9.7459 L10.7847,14.9609 Z M11.9997,3.9999 C7.5817,3.9999 3.9997,7.5819 3.9997,11.9999 C3.9997,16.4179 7.5817,19.9999 11.9997,19.9999 C16.4187,19.9999 19.9997,16.4179 19.9997,11.9999 C19.9997,7.5819 16.4187,3.9999 11.9997,3.9999 L11.9997,3.9999 Z", fillRule: "evenodd" })));
};
SelectFill.displayName = 'SelectFill';
exports.default = SelectFill;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=SelectFill.js.map